import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
// @ts-ignore
import HomeHeroVideo from "../../Assets/Home/TheElystrionVideowithOldMusic.mp4"
// @ts-ignore
import videothumbnail from "../../Assets/Home/ElystrionVideoThumbnail.png";
import Hls from "hls.js";
import { Play, Pause } from "lucide-react";

const MainVideoSection = () => {
    const [hasStarted, setHasStarted] = useState(false);
    const videoRef = useRef<HTMLVideoElement>(null);
    const hlsRef = useRef<Hls | null>(null);

    const hlsUrl = process.env.REACT_APP_PORTAL_MAIN_VIDEO_URL;

    const initHls = () => {
        const video = videoRef.current;
        if (!video) return;

        if (Hls.isSupported()) {
            const hls = new Hls();
            hls.loadSource(hlsUrl);
            hls.attachMedia(video);
            hlsRef.current = hls;
        } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
            // Safari / iOS
            video.src = hlsUrl;
        }
    };

    useEffect(() => {
        initHls();
    }, []);

    const handlePlay = () => {
        if (!hasStarted) {
            initHls(); // load HLS only when user clicks play
            setHasStarted(true);
        }
        if (videoRef.current.requestFullscreen) {
            videoRef.current.requestFullscreen();
        }
        videoRef.current?.play();
    };

    return (
        <section className="w-full h-screen pb-[0] aspect-[16/9]" id="video-main">
            {/* {!hasStarted && ( */}
            <div className={`${!hasStarted ? "block relative inset-0 w-full h-screen pb-[0]" : "hidden"}`}>
                <motion.img
                    className="relative w-full h-full object-cover z-10 "
                    src={videothumbnail}
                    alt="Hero Background"
                    initial={{ opacity: 0, scale: 1.05 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 1.5, ease: "easeOut" }}
                />
                <div className="bg-black/40 absolute inset-0 flex items-center justify-center z-20 flex-col lg:pt-[8rem]">
                    <h2 className="font-semi-bold adjustLetterSpacing text-[#ffffff] text-[48px] sm:text-[60px] md:text-[72px] w-8/12 xl:w-4/12 text-center leading-tight">Where Luxury Finds Its Truth</h2>
                    <button className="button play grey px-6 py-3 rounded-full text-white font-regular shadow-lg border-solid border-[rgba(255,255,255,0.5)] mt-[45px]" onClick={handlePlay}>
                        <span>Play Video</span> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M0 12C0 5.37258 5.37258 0 12 0V0C18.6274 0 24 5.37258 24 12V12C24 18.6274 18.6274 24 12 24V24C5.37258 24 0 18.6274 0 12V12Z" fill="#171717" />
                            <path d="M9 6V18L18 12L9 6Z" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </button>
                </div>
            </div>
            {/* )} */}

            <motion.video
                // @ts-ignore
                // className={`${!hasStarted ? 'hidden' : 'block top-0 left-0 w-screen h-screen object-cover z-[9999] pb-[6rem] xl:pb[8rem]'}`}
                className={`top-0 left-0 w-screen h-screen object-cover z-[9999]
                    transition-opacity duration-700 ease-in-out
                    ${!hasStarted ? 'opacity-0 pointer-events-none' : 'opacity-100'}`}
                ref={videoRef}
                // playsInline
                // webkit-playsinline // important for iOS to play inline
                controls
                onEnded={() => {
                    setTimeout(() => {
                        if (document.fullscreenElement) {
                            document.exitFullscreen?.().catch(() => { });
                        } else if ((document as any).webkitFullscreenElement) {
                            (document as any).webkitExitFullscreen?.();
                        }

                        setHasStarted(false);
                        if (videoRef && videoRef?.current) {
                            videoRef?.current?.pause();      // stop video
                            videoRef.current.currentTime = 0; // rewind to start
                        }
                    }, 600); // match your fade duration
                }}
                initial={{ opacity: 0, scale: 1.05 }}
                animate={{ opacity: !hasStarted ? 0 : 1, scale: 1 }}
                transition={{ duration: 1.5, ease: "easeOut" }}
            >
                Your browser does not support the video tag.
            </motion.video>
        </section>
    );
};

export default MainVideoSection;